import { DocumentReferenceUploadPayload } from '@qtek/shared/models';

/**
 * Builds the multipart body for the new `*DocumentReference` upload contract
 * (`entityType` + `entityId` + `attribute`, replacing the legacy
 * `_ks`/`_attr`/`_acc`/`_dsc` docref fields). Centralized so every migrated
 * upload site sends the same field names.
 *
 * Optional fields are omitted rather than sent empty: the backend defaults
 * `attribute` per entity type, and treats a blank `entityJson` as "attach to
 * `entityId`" — sending either as an empty string changes that behaviour.
 */
export function buildDocumentReferenceFormData(
  payload: DocumentReferenceUploadPayload
): FormData {
  const formData = new FormData();

  formData.append('file', payload.file, payload.fileName);
  formData.append('accessLevel', payload.accessLevel);
  if (payload.description) {
    formData.append('description', payload.description);
  }
  formData.append('entityType', payload.entityType);
  if (payload.entityId) {
    formData.append('entityId', payload.entityId);
  }
  if (payload.attribute) {
    formData.append('attribute', payload.attribute);
  }
  if (payload.categoryId) {
    formData.append('categoryId', payload.categoryId);
  }
  if (payload.entityJson) {
    formData.append('entityJson', payload.entityJson);
  }
  if (payload.documentType) {
    formData.append('documentType', payload.documentType);
  }

  return formData;
}
